import { runInAction, makeAutoObservable } from "mobx";
// helpers
// models
// apis
import ContactApi from "src/store/apis/contact-api";

class ContactStore {
  isUpdating = false;

  constructor() {
    makeAutoObservable(this);
  }

  resetState() {}

  async store(payload = null) {
    try {
      let _default = {};

      let reqParams = { ..._default, ...payload };

      runInAction(() => {
        this.isUpdating = true;
      });

      return await ContactApi.store(reqParams)
        .then((response) => {
          if (response.success != 1) {
            return response.status;
          }

          let data = response.data;

          return data;
        })
        .finally(() => {
          runInAction(() => {
            this.isUpdating = false;
          });
        });
    } catch (e) {}
  }
}

export default ContactStore;
